import { Box } from "@material-ui/core";
import { Button, ContainerPage, OptionsMenu, TitlePage } from "components";
import { useTableParams } from "hooks/useTableParams";
import { useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";
import productShelfLifeService from "services/productShelfLifeService";
import { Table } from "shared";
import { formatDateTime, mapType } from "utils";

import { ShelfLifeDrawer } from "./components/ShelfLifeDrawer";
import { useStyles } from "./styles";

const formatUpdatedAt = value => {
  if (!value) return "-";
  const { date, time } = formatDateTime(value);
  return `${date} ${time}`;
};

export const ProductShelfLife = () => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { data, onChange, params, refresh, status, handleSearch, count } =
    useTableParams({
      paramsDefault: { status: "active" },
      service: requestParams => productShelfLifeService.list(requestParams)
    });

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const handleDrawerExited = () => {
    setSelectedProduct(null);
  };

  const openDrawer = product => {
    setSelectedProduct(product || null);
    setDrawerOpen(true);
  };

  const columns = [
    {
      field: "id",
      label: "ID",
      align: "center",
      disabledSort: true,
      style: { width: "6rem" }
    },
    {
      field: "name",
      label: "Produto",
      align: "left",
      disabledSort: true
    },
    {
      field: "purchase_type",
      label: "Porção",
      align: "center",
      disabledSort: true,
      formatter: mapType
    },
    {
      field: "shelfLifeA",
      label: "Shelf life A (dias)",
      align: "center",
      disabledSort: true
    },
    {
      field: "shelfLifeB",
      label: "Shelf life B (dias)",
      align: "center",
      disabledSort: true
    },
    {
      field: "shelfLifeC",
      label: "Shelf life C (dias)",
      align: "center",
      disabledSort: true
    },
    {
      field: "shelfLifeUpdated",
      label: "Atualizado em",
      align: "center",
      disabledSort: true,
      formatter: formatUpdatedAt
    },
    {
      field: "updatedBy",
      label: "Editado por",
      align: "center",
      disabledSort: true,
      formatter: value => value?.username || "-"
    },
    {
      field: "",
      label: "",
      align: "center",
      disabledSort: true,
      renderCell: ({ data: product }) => (
        <OptionsMenu
          data={product}
          options={[
            {
              title: "Visualizar/editar",
              icon: FiEdit2,
              permissions: ["Estoque", "Tech", "Admin", "Stock View"],
              action: () => openDrawer(product)
            }
          ]}
        />
      )
    }
  ];

  return (
    <ContainerPage>
      <Box className={classes.header}>
        <TitlePage>Shelf life por produto</TitlePage>
        <Button
          variant="contained"
          startIcon={<IoMdAdd />}
          className={classes.addButton}
          onClick={() => openDrawer()}
        >
          Adicionar
        </Button>
      </Box>

      <Table
        handleSearch={handleSearch}
        columns={columns}
        data={data}
        onChange={onChange}
        params={params}
        status={status}
        refresh={refresh}
        count={count}
        placeholder="Pesquisar produto"
      />

      <ShelfLifeDrawer
        open={drawerOpen}
        close={closeDrawer}
        onExited={handleDrawerExited}
        product={selectedProduct}
        onSaved={refresh}
      />
    </ContainerPage>
  );
};
